export const radii = {
  "none": "0",
  "xs": "0.1875rem",
  "sm": "0.25rem",
  "base": "0.375rem",
  "md": "0.375rem",
  "lg": "0.5rem",
  "xl": "0.75rem",
  "2xl": "1rem",
  "3xl": "1.75rem",
  "4xl": "2.25rem",
  "full": "9999px",
  "circle": "50%",
  "rounded": "full"
};